<template>
  <div class="relative pt-4">
    <div class="blue-grid absolute inset-0 bg-grid-slate-100 [mask-image:linear-gradient(0deg,#fff,rgba(255,255,255,0.6))]" style="background-position: 10px 10px;"></div>
    <h3 class="ml-4 font-bold text-lg relative z-10">Variants</h3>

    <div class="w-full border-b border-gray-100 rounded-t-lg">
      <ul v-if="loading" class="h-48 flex h-full space-x-3 overflow-auto p-4 relative">
        <li
          v-for="(src, index) in placeholderVariants"
          :key="index"
          class="border shrink-0 h-full forced-ske border-gray-100 h-full bg-white rounded relative hover:border-gray-200 cursor-pointer"
        >
          <img
            class="h-full aspect-w-2 rounded"
            :src="src"
          >
        </li>
      </ul>
      <ul v-else class="flex space-x-3 overflow-auto p-4 relative">
        <li
          v-for="(variant, index) in sortedVariants"
          :key="variant"

          class="h-full w-80 shrink-0 relative"
        >
          <h4 class="capitalize mb-2" :class="index === 0 ? 'italic text-gray-400' : 'font-medium'">{{ variant.replace(/(_|-)/g, ' ') }}</h4>
          <div class="relative">
            <BlockPreview
              class="h-48 w-full bg-white"
              :variant="variant"
              :remove-title="true"
              height="h-full"
              scale="scale(.25, .25)"
              iframe-transform="translateX(0px)"
              :disabled="true"
              :wrapper-class="`duration-100 ${isSelected(variant, index, selected) ? '!border-gray-300' : '!border-gray-100 hover:!border-gray-300'}`"

              :id="id"
              :title="title"
              :role="role"
              @click.native="selectVariant(variant)"
            />

            <span class="absolute left-0 top-0 ml-2 mt-2 bg-white rounded-full">
              <svg v-if="isSelected(variant, index, selected)" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6 scale-125">
                <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clip-rule="evenodd" />
              </svg>
            </span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

import BlockPreview from "@/components/SideEditor/BlocksFinder/BlockPreview"

export default {
  props: ['loading', 'variants', 'title', 'role', 'id', 'configuration', 'currentConfig'],
  components: {
    BlockPreview,
  },
  data() {
    return {
      placeholderVariants: [
        "https://tailwindui.com/img/category-thumbnails/marketing/heroes.png",
        "https://tailwindui.com/img/category-thumbnails/marketing/pricing.png",
      ],
    }
  },
  methods: {
    isSelected(variant, index, selected) {
      return (selected === variant) || index === 0 && selected === null
    },
    selectVariant(variant) {
      console.warn("setBlockConfig: ", "selectVariant")
      this.$store.dispatch('editor/setBlockConfig', {
        id: this.id,
        role: this.role,
        config: { variant: variant === 'default' ? null : variant },
      })
    },
  },
  computed: {
    sortedVariants() {
      return [
        'default',
        ...this.variants.filter(item => item !== 'default'),
      ]
    },
    selected() {
      return (this.currentConfig && this.currentConfig.variant) || null
    },
  },
}

</script>
